<template>
  <div class="space-information">
    <div class="space-information--title">
      {{$store.getters.language.information}}

    </div>
    <div class="space-information--description" v-html="data"></div>
    {{opening_time}}
    <br>
    {{access_time}}
    <br>
    <br>
    <div v-if="!center && formattedDimensions">
      {{ formattedDimensions }}
      <br>
      <br>
      <br>
    </div>
    <template v-if="center">
      <SpacesPills v-if="categories" :data="categories"></SpacesPills>      
    </template>
    <template v-else>
      <SpacesCategories v-if="categories" :data="categories"></SpacesCategories>      
    </template>
  </div>
</template>

<script>
import SpacesPills from "../../components/search/SpacesPills"
import SpacesCategories from "../../components/search/SpacesCategories"

export default {
  name: 'SpacesInformation',
  data: () => ({
  }),
  props: ['data', 'categories', 'center', 'opening_time', 'access_time', 'dimensions'],
  components: {
    SpacesPills,
    SpacesCategories
  },
  computed: {
    formattedDimensions() {
      const translations = this.$store.getters.language;

      if (!this.dimensions) {
        return translations['listing_dimensions_to_be_confirmed'];
      }

      const matches = this.dimensions.match(/([HWL]):\s?([\d,.]+)m/g);

      if (!matches) {
        return translations['listing_dimensions_to_be_confirmed'];
      }

      const parsed = matches.reduce((acc, item) => {
        const [, key, value] = item.match(/([HWL]):\s?([\d,.]+)m/) || [];
        if (key && value) acc[key] = value;
        return acc;
      }, {});

      const width = parsed["W"];
      const length = parsed["L"];
      const height = parsed["H"];

      if (width && length && height) {
        return `${translations['listing_dimensions_width']}: ${width}m | ` +
            `${translations['listing_dimensions_length']}: ${length}m | ` +
            `${translations['listing_dimensions_height']}: ${height}m`;
      } else {
        return translations['listing_dimensions_to_be_confirmed'];
      }
    }
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/global/includes";

.space-information {
  width: 100%;
  background: $light-grey;
  color: $primary-grey;
  padding: 32px;
  border-radius: 4px;
}
.space-information--title {
  width: 100%;
  display: block;
  @include responsive-text-size('Header--13--BOLD');
  padding-bottom: 16px;
  margin-bottom: 19px;
  border-bottom: 1px solid $divider-dark;
}

.space-information--description {
  margin-bottom: 20px;
}

</style>
